import { Card, Inline, Text, textVariants } from '@etg/wings';
import { useDateFormat, useTranslation } from '@eti/providers';
import { constants, date as dateFormatter, price as priceUtil } from '@eti/utils';
import { css } from '@eti/styles';
import { Fragment } from 'react';
import { useOrderDetails } from '../../../../containers/OrderDetailsContext';
import PaymentItem from './PaymentItem';

const inlineStyles = css`
  justify-content: space-between;
`;

const greyBackgroundStyles = css`
  background-color: #d6d6d6;
`;

interface AddOnOrdersProps {
  sumLabel: string;
}

const AddOnOrders = ({ sumLabel }: AddOnOrdersProps) => {
  const { t } = useTranslation();
  const { date } = useDateFormat();
  const { addOnOrders } = useOrderDetails();

  return (
    <>
      {addOnOrders.map(({ creationDate, extraProducts, orderNumber, price }, index) => (
        <Fragment key={index}>
          <Card.Section
            className={greyBackgroundStyles}
            data-testid={`priceSpecification-postBooking-orderNumber-${orderNumber}-info`}
          >
            <Inline className={inlineStyles}>
              <Text>{t('Order.Receipt.PostbookingPurchase.Label')}</Text>
              <Text className={constants.MOUSE_FLOW_CLASS_NAMES}>
                {dateFormatter.format(creationDate, date)}
              </Text>
            </Inline>
          </Card.Section>
          {extraProducts &&
            extraProducts.map(
              (extraProduct) =>
                extraProduct && (
                  <PaymentItem
                    dataTestId={`priceSpecification-postBooking-orderNumber-${orderNumber}-product-${extraProduct.name}`}
                    key={`${orderNumber}-product-${extraProduct.name}`}
                    price={priceUtil.formatPrice(extraProduct.price.price.value)}
                    title={extraProduct.name}
                  />
                ),
            )}
          {price && (
            <PaymentItem
              dataTestId={`priceSpecification-postBooking-orderNumber-${orderNumber}-total-price`}
              price={priceUtil.formatPrice(price.price.value)}
              textVariant={textVariants._14_BOLD}
              title={sumLabel}
            />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default AddOnOrders;
